import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Flower2, Loader2 } from "lucide-react";
import { useAdminAuth } from "../AuthContext";
import { formatApiErrorDetail } from "../api";

const Login = () => {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user.role) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      navigate(u.must_change_password ? "/admin/skift-adgangskode" : "/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.detail) || "Login mislykkedes.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A2E24] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 text-white">
          <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#2D5A3F]">
            <Flower2 className="h-6 w-6" strokeWidth={1.5} />
          </span>
          <div>
            <p className="font-display text-2xl leading-none">Lotusgruppen</p>
            <p className="text-xs uppercase tracking-[0.25em] text-white/50 mt-1">Internt adminpanel</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-xl" data-testid="admin-login-form">
          <h1 className="font-display text-2xl text-[#1A2E24] mb-1">Log ind</h1>
          <p className="text-sm text-[#5C7567] mb-6">Adgang kun for autoriseret personale.</p>

          <label className="block text-xs uppercase tracking-wide text-[#5C7567] mb-1.5">E-mail</label>
          <input
            type="email"
            required
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email"
            className="w-full mb-4 rounded-xl border border-black/10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2D5A3F]/40"
          />

          <label className="block text-xs uppercase tracking-wide text-[#5C7567] mb-1.5">Adgangskode</label>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password"
            className="w-full mb-5 rounded-xl border border-black/10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2D5A3F]/40"
          />

          {error && (
            <p className="text-sm text-red-600 mb-4" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 rounded-full bg-[#2D5A3F] text-white py-3 font-medium hover:bg-[#244b34] transition-colors duration-200 disabled:opacity-60"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Log ind
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
